<style lang="scss" scoped>
  .md-app {
    min-height: 350px;
    border: 1px solid rgba(#000, 0.12);
  }

  // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }

</style>

<template>
  <basic-layout>
    <md-app>
      <md-app-toolbar class="md-primary" md-elevation="0">
         <div class="md-toolbar-row" v-if="!isAuthenticated()">

          <div class="md-toolbar-section-start">
            <div class="md-title">
              {{$t("admintools")}}
            </div>
          </div>
        </div>

        <div class="md-toolbar-row" v-if="isAuthenticated()">

          <div class="md-toolbar-section-start">
            <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
              <md-icon>menu</md-icon>
            </md-button>
            <div class="md-title">
              {{$t("admintools")}}
            </div>
          </div>

          <div class="md-toolbar-section-end">
            <md-button class="billing-company-button md-xsmall-hide" v-if="selectedBillingCompany" @click="changeBillingCompany">
              <!-- <img class="billing-company-logo" v-if="selectedBillingCompany.logoUrl" :src=selectedBillingCompany.logoUrl :alt=selectedBillingCompany.name> -->
              {{selectedBillingCompany.companyName}}
            </md-button>
            <md-menu md-direction="bottom-start">
              <md-button md-menu-trigger>
                <md-icon v-if="!user || !user.thumbPictureUrl">account_circle</md-icon>
                <md-avatar v-else>
                  <img :src=user.thumbPictureUrl :alt=user.accountUsername>
                </md-avatar>
              </md-button>
              <md-menu-content>
                <md-menu-item @click="changeBillingCompany">Change billing company</md-menu-item>
                <md-menu-item @click="logout">Logout</md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </div>

      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">
          <div class="md-toolbar-section-start">
            <!-- <div class="md-title"> -->
            <img src="../../assets/img/mywellness-logo.png" alt="mywellness" />
            <!-- </div> -->
          </div>
          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>

        </md-toolbar>

        <md-list>

          <md-list-item v-if="currentEnvironment === 'debug' || currentEnvironment === 'development'" md-expand>
            <md-icon>create</md-icon>
            <span class="md-list-item-text">{{$t("testenvironment")}}</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset" @click="createTestFacility">Club</md-list-item>
              <md-list-item class="md-inset" @click="createTestChain">Chain</md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>search</md-icon>
            <span class="md-list-item-text">Search</span>

            <md-list slot="md-expand">
              <md-list-item class="md-inset" @click="searchFacility"><md-icon>fitness_center</md-icon><span class="md-list-item-text">Facility</span></md-list-item>
              <md-list-item class="md-inset" @click="searchChain"> <md-icon>share</md-icon><span class="md-list-item-text">Chain</span></md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <md-icon>build</md-icon>
            <span class="md-list-item-text">Integrator</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" @click="createIntegrator"><md-icon>add</md-icon><span class="md-list-item-text">Create</span></md-list-item>
              <md-list-item class="md-inset" @click="listIntegrators"> <md-icon>list</md-icon><span class="md-list-item-text">Integrators</span></md-list-item>
              <md-list-item class="md-inset" @click="integratedfacilities"> <md-icon>fitness_center</md-icon><span class="md-list-item-text">Facilities</span></md-list-item>
            </md-list>
          </md-list-item>

          <md-list-item @click="convertAccount">
            <md-icon>cached</md-icon>
            <span class="md-list-item-text">Convert Account</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content>
        <slot name="title"></slot>
        <breadcrumb />
        <slot name="abstract"></slot>
        <slot></slot>
      </md-app-content>

    </md-app>
   <md-snackbar :md-active.sync="showNotification" :md-duration="Infinity"><span>{{notificationMessage}}</span><md-button class="md-primary" @click="showNotification = false">Close</md-button></md-snackbar>
  </basic-layout>
</template>

<script>
import BasicLayout from '@/components/layouts/basic'
import RepositoryService from '@/services/repositoryService'
import router from '@/router'
import Breadcrumb from '@/components/elements/breadcrumbs'

export default {
  name: 'NavBar',
  components: {
    BasicLayout,
    Breadcrumb
  },
  data: () => ({
    currentEnvironment: process.env.NODE_ENV,
    menuVisible: false,
    user: null,
    selectedBillingCompany: null,
    notificationMessage: null,
    showNotification: false
  }),
  methods: {
    setNotification (notificationMessage) {
      this.showNotification = true
      this.notificationMessage = notificationMessage
    },
    setErrorNotification (errors) {
      this.showNotification = true
      this.notificationMessage = errors.map((field) => { return field.errorMessage ? field.errorMessage : field.details }).join('; ')
    },
    toggleMenu () {
      this.menuVisible = !this.menuVisible
    },
    async logout () {
      await RepositoryService.session.clear()
      router.push({
        name: 'login'
      })
    },
    changeBillingCompany () {
      router.push({
        name: 'selectbillingcompany',
        params: {
          facilities: RepositoryService.session.facilities
        }
      })
    },
    createIntegrator () {
      router.push({
        name: 'createintegrator'
      })
    },
    createTestFacility () {
      router.push({
        name: 'createtestfacility'
      })
    },
    listIntegrators () {
      router.push({
        name: 'listIntegrators'
      })
    },
    createTestChain () {
      router.push({
        name: 'createtestchain'
      })
    },
    searchFacility () {
      router.push({
        name: 'searchfacility'
      })
    },
    searchChain () {
      router.push({
        name: 'searchchain'
      })
    },
    convertAccount () {
      router.push({
        name: 'convertaccount'
      })
    },
    integratedfacilities () {
      router.push({
        name: 'integratedfacilities'
      })
    },
    isAuthenticated () {
      return RepositoryService.session.isUserLoggedIn()
    }
  },
  created: function () {
    if (RepositoryService.session.isUserLoggedIn()) {
      this.user = RepositoryService.session.user
    }
    if (RepositoryService.session.isUserLoggedInWithBillingCompany()) {
      this.selectedBillingCompany = RepositoryService.session.selectedBillingCompany
    }
  }
}

</script>

<style>
  .billing-company-logo {
    max-width: 110px;
    max-height: 50px;
    vertical-align: middle;
    margin-right: 20px;
  }

</style>
